import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCMSAccordion, LazyCMSAccordionEntry, LazyCMSBanner, LazyCMSBannerLink, LazyCMSBannerWrapper, LazyCMSClickableImage, LazyCMSContentPage, LazyCMSContentSlide, LazyCMSContentSlider, LazyCMSContentfulLink, LazyCMSDetailImage, LazyCMSDoubleColumn, LazyCMSGrid, LazyCMSGridTile, LazyCMSHeroBronze, LazyCMSHeroGold, LazyCMSHtmlComponent, LazyCMSImage, LazyCMSImageSlider, LazyCMSImageSliderSlide, LazyCMSImageText, LazyCMSLink, LazyCMSNestedParagraph, LazyCMSParagraph, LazyCMSPostListingPage, LazyCMSProduct, LazyCMSProductListingPageHero, LazyCMSProductListingPageTeaser, LazyCMSProductSlider, LazyCMSScrollableLinkList, LazyCMSSlide, LazyCMSSlideShow, LazyCMSStory, LazyCMSText, LazyCMSVideo, LazyCMSHeadingNode, LazyCMSHrNode, LazyCMSHyperlinkNode, LazyCMSInlineEntry, LazyCMSListItemNode, LazyCMSOrderedListNode, LazyCMSParagraphNode, LazyCMSQuoteNode, LazyCMSRichTextNode, LazyCMSTextMarks, LazyCMSTextNode, LazyCMSUnorderedListNode, LazyCMSContentfulRichTextRenderer, LazyIconAccount, LazyIconAddToCart, LazyIconAj, LazyIconAngleDown, LazyIconArrowLeft, LazyIconBack, LazyIconBasket, LazyIconBox, LazyIconBurger, LazyIconCap, LazyIconCart, LazyIconCheckGreen, LazyIconCheck, LazyIconCheckboxAct, LazyIconCheckboxDisAct, LazyIconCheckboxDis, LazyIconCheckbox, LazyIconCheckmark, LazyIconChevronDownMini, LazyIconChevronDown, LazyIconChevronLeftMini, LazyIconChevronLeft, LazyIconChevronRightMini, LazyIconChevronRight, LazyIconChevronUp, LazyIconClockOutline, LazyIconClock, LazyIconCloseSBold, LazyIconCloseS, LazyIconClose, LazyIconCollect, LazyIconContact, LazyIconCreditcard, LazyIconDate, LazyIconDelivered, LazyIconDelivery, LazyIconDiffDelivery, LazyIconDirection, LazyIconDiscount, LazyIconDoc, LazyIconDown, LazyIconDropdown, LazyIconEditUser, LazyIconEdit, LazyIconEmptyBasket, LazyIconEmptyWishlist, LazyIconEquals, LazyIconErrorHexagon, LazyIconError, LazyIconFb, LazyIconFilter, LazyIconFlagsAt, LazyIconFlagsBe, LazyIconFlagsCh, LazyIconFlagsDe, LazyIconFlagsEs, LazyIconFlagsFr, LazyIconFlagsHr, LazyIconFlagsIt, LazyIconFlagsNl, LazyIconFlagsPl, LazyIconFlagsPt, LazyIconFlagsUs, LazyIconForward, LazyIconGerman, LazyIconGift, LazyIconGlobe, LazyIconGoogleMaps, LazyIconHeartActivePurple, LazyIconHeartActive, LazyIconHeartBold, LazyIconHeartCircle, LazyIconHeartFull, LazyIconHeartInactive, LazyIconHeart, LazyIconHourglass, LazyIconInfoOutlineSquare, LazyIconInfoOutline, LazyIconInfo, LazyIconInvoice, LazyIconLeft, LazyIconLetter, LazyIconLocationMenu, LazyIconLocation, LazyIconLock, LazyIconLogo, LazyIconLogoutRound, LazyIconLogout, LazyIconMail, LazyIconMinus, LazyIconMultiplyOutline, LazyIconNotify, LazyIconOrderMulti, LazyIconOrder, LazyIconPasswordHide, LazyIconPasswordShow, LazyIconPayback, LazyIconPaymentDinersclub, LazyIconPaymentDiscover, LazyIconPaymentKlarna, LazyIconPaymentLastschrift, LazyIconPaymentMastercard, LazyIconPaymentOspBankTransfer, LazyIconPaymentOspKlarna, LazyIconPaymentOspMastercard, LazyIconPaymentOspPaypal, LazyIconPaymentOspVisa, LazyIconPaymentOspVoucher, LazyIconPaymentPaypal, LazyIconPaymentRatepay, LazyIconPaymentSofort, LazyIconPaymentVisa, LazyIconPen, LazyIconPhone, LazyIconPlus, LazyIconPromotion, LazyIconRadioOff, LazyIconRadioOn, LazyIconReturn, LazyIconRight, LazyIconSameDelivery, LazyIconScreenClick, LazyIconSearchBold, LazyIconSearch, LazyIconSelectionActive, LazyIconSelection, LazyIconSettings, LazyIconShare, LazyIconShippingDhl, LazyIconShippingUps, LazyIconSnipesAccount, LazyIconSnipesAddress, LazyIconSnipesAppandroid, LazyIconSnipesAppapple, LazyIconSnipesArrowcarouselsleft, LazyIconSnipesArrowcarouselsright, LazyIconSnipesArrowcircledown, LazyIconSnipesArrowcircleleft, LazyIconSnipesArrowcircleright, LazyIconSnipesArrowcircleup, LazyIconSnipesArrowsmalldown, LazyIconSnipesArrowsmallleft, LazyIconSnipesArrowsmallright, LazyIconSnipesArrowsmallup, LazyIconSnipesBackarrowcircle, LazyIconSnipesBacktotoparrow, LazyIconSnipesBadgediscount, LazyIconSnipesBarcode, LazyIconSnipesBurgermenu, LazyIconSnipesCalendarevents, LazyIconSnipesCheckmarkcircleoutlined, LazyIconSnipesCheckmarkcirclesolid, LazyIconSnipesCirclepause, LazyIconSnipesCircleplay, LazyIconSnipesClosecircleoutlined, LazyIconSnipesClosecirclesolid, LazyIconSnipesCoinsoutlined, LazyIconSnipesCookie, LazyIconSnipesCopy, LazyIconSnipesCountryselection, LazyIconSnipesDashboard, LazyIconSnipesDeletetrash, LazyIconSnipesDeliveryclickandcollect, LazyIconSnipesDeliveryhomedelivery, LazyIconSnipesDeliverypickupstation, LazyIconSnipesDeliverytruck, LazyIconSnipesEdit, LazyIconSnipesEditprofile, LazyIconSnipesExclamationmarkoutlined, LazyIconSnipesExclamationmarksolid, LazyIconSnipesFacebook, LazyIconSnipesFacehappy, LazyIconSnipesFaceneutral, LazyIconSnipesFacesad, LazyIconSnipesFaq, LazyIconSnipesFaqpayment, LazyIconSnipesFaqvoucher, LazyIconSnipesFeedbackcheck, LazyIconSnipesFeedbackx, LazyIconSnipesFilterelement, LazyIconSnipesGeolocation, LazyIconSnipesGift, LazyIconSnipesHeartoutlined, LazyIconSnipesHeartsolid, LazyIconSnipesInfocircle, LazyIconSnipesInstagram, LazyIconSnipesLogout, LazyIconSnipesMailboxed, LazyIconSnipesMailoutlined, LazyIconSnipesMailsolid, LazyIconSnipesMinuscircle, LazyIconSnipesMinuslight, LazyIconSnipesNewsletter, LazyIconSnipesOrders, LazyIconSnipesPackage, LazyIconSnipesPassword, LazyIconSnipesPaymentmethods, LazyIconSnipesPhoneboxed, LazyIconSnipesPhoneoutlined, LazyIconSnipesPhonesolid, LazyIconSnipesPluscircle, LazyIconSnipesPluslight, LazyIconSnipesQrcode, LazyIconSnipesReturn, LazyIconSnipesSearch, LazyIconSnipesSecureshopping, LazyIconSnipesSecurityshield, LazyIconSnipesSheetrecycle, LazyIconSnipesShoplight, LazyIconSnipesShoppingbag, LazyIconSnipesShoppingbagempty, LazyIconSnipesShowpassword, LazyIconSnipesSpotify, LazyIconSnipesStore, LazyIconSnipesStorefinder, LazyIconSnipesTiktok, LazyIconSnipesTrimanlogo, LazyIconSnipesWhatsapp, LazyIconSnipesWishlist, LazyIconSnipesWishlistsolid, LazyIconSnipesYoutube, LazyIconSnipesZoomin, LazyIconSnipesZoomout, LazyIconSocialFacebook, LazyIconSocialInstagram, LazyIconSocialLinkedin, LazyIconSocialMessenger, LazyIconSocialSnapchat, LazyIconSocialTwitter, LazyIconSocialYoutube, LazyIconSsl, LazyIconTrash, LazyIconUp, LazyIconUserSecondary, LazyIconUser } from '#components'
const lazyGlobalComponents = [
  ["CMSAccordion", LazyCMSAccordion],
["CMSAccordionEntry", LazyCMSAccordionEntry],
["CMSBanner", LazyCMSBanner],
["CMSBannerLink", LazyCMSBannerLink],
["CMSBannerWrapper", LazyCMSBannerWrapper],
["CMSClickableImage", LazyCMSClickableImage],
["CMSContentPage", LazyCMSContentPage],
["CMSContentSlide", LazyCMSContentSlide],
["CMSContentSlider", LazyCMSContentSlider],
["CMSContentfulLink", LazyCMSContentfulLink],
["CMSDetailImage", LazyCMSDetailImage],
["CMSDoubleColumn", LazyCMSDoubleColumn],
["CMSGrid", LazyCMSGrid],
["CMSGridTile", LazyCMSGridTile],
["CMSHeroBronze", LazyCMSHeroBronze],
["CMSHeroGold", LazyCMSHeroGold],
["CMSHtmlComponent", LazyCMSHtmlComponent],
["CMSImage", LazyCMSImage],
["CMSImageSlider", LazyCMSImageSlider],
["CMSImageSliderSlide", LazyCMSImageSliderSlide],
["CMSImageText", LazyCMSImageText],
["CMSLink", LazyCMSLink],
["CMSNestedParagraph", LazyCMSNestedParagraph],
["CMSParagraph", LazyCMSParagraph],
["CMSPostListingPage", LazyCMSPostListingPage],
["CMSProduct", LazyCMSProduct],
["CMSProductListingPageHero", LazyCMSProductListingPageHero],
["CMSProductListingPageTeaser", LazyCMSProductListingPageTeaser],
["CMSProductSlider", LazyCMSProductSlider],
["CMSScrollableLinkList", LazyCMSScrollableLinkList],
["CMSSlide", LazyCMSSlide],
["CMSSlideShow", LazyCMSSlideShow],
["CMSStory", LazyCMSStory],
["CMSText", LazyCMSText],
["CMSVideo", LazyCMSVideo],
["CMSHeadingNode", LazyCMSHeadingNode],
["CMSHrNode", LazyCMSHrNode],
["CMSHyperlinkNode", LazyCMSHyperlinkNode],
["CMSInlineEntry", LazyCMSInlineEntry],
["CMSListItemNode", LazyCMSListItemNode],
["CMSOrderedListNode", LazyCMSOrderedListNode],
["CMSParagraphNode", LazyCMSParagraphNode],
["CMSQuoteNode", LazyCMSQuoteNode],
["CMSRichTextNode", LazyCMSRichTextNode],
["CMSTextMarks", LazyCMSTextMarks],
["CMSTextNode", LazyCMSTextNode],
["CMSUnorderedListNode", LazyCMSUnorderedListNode],
["CMSContentfulRichTextRenderer", LazyCMSContentfulRichTextRenderer],
["IconAccount", LazyIconAccount],
["IconAddToCart", LazyIconAddToCart],
["IconAj", LazyIconAj],
["IconAngleDown", LazyIconAngleDown],
["IconArrowLeft", LazyIconArrowLeft],
["IconBack", LazyIconBack],
["IconBasket", LazyIconBasket],
["IconBox", LazyIconBox],
["IconBurger", LazyIconBurger],
["IconCap", LazyIconCap],
["IconCart", LazyIconCart],
["IconCheckGreen", LazyIconCheckGreen],
["IconCheck", LazyIconCheck],
["IconCheckboxAct", LazyIconCheckboxAct],
["IconCheckboxDisAct", LazyIconCheckboxDisAct],
["IconCheckboxDis", LazyIconCheckboxDis],
["IconCheckbox", LazyIconCheckbox],
["IconCheckmark", LazyIconCheckmark],
["IconChevronDownMini", LazyIconChevronDownMini],
["IconChevronDown", LazyIconChevronDown],
["IconChevronLeftMini", LazyIconChevronLeftMini],
["IconChevronLeft", LazyIconChevronLeft],
["IconChevronRightMini", LazyIconChevronRightMini],
["IconChevronRight", LazyIconChevronRight],
["IconChevronUp", LazyIconChevronUp],
["IconClockOutline", LazyIconClockOutline],
["IconClock", LazyIconClock],
["IconCloseSBold", LazyIconCloseSBold],
["IconCloseS", LazyIconCloseS],
["IconClose", LazyIconClose],
["IconCollect", LazyIconCollect],
["IconContact", LazyIconContact],
["IconCreditcard", LazyIconCreditcard],
["IconDate", LazyIconDate],
["IconDelivered", LazyIconDelivered],
["IconDelivery", LazyIconDelivery],
["IconDiffDelivery", LazyIconDiffDelivery],
["IconDirection", LazyIconDirection],
["IconDiscount", LazyIconDiscount],
["IconDoc", LazyIconDoc],
["IconDown", LazyIconDown],
["IconDropdown", LazyIconDropdown],
["IconEditUser", LazyIconEditUser],
["IconEdit", LazyIconEdit],
["IconEmptyBasket", LazyIconEmptyBasket],
["IconEmptyWishlist", LazyIconEmptyWishlist],
["IconEquals", LazyIconEquals],
["IconErrorHexagon", LazyIconErrorHexagon],
["IconError", LazyIconError],
["IconFb", LazyIconFb],
["IconFilter", LazyIconFilter],
["IconFlagsAt", LazyIconFlagsAt],
["IconFlagsBe", LazyIconFlagsBe],
["IconFlagsCh", LazyIconFlagsCh],
["IconFlagsDe", LazyIconFlagsDe],
["IconFlagsEs", LazyIconFlagsEs],
["IconFlagsFr", LazyIconFlagsFr],
["IconFlagsHr", LazyIconFlagsHr],
["IconFlagsIt", LazyIconFlagsIt],
["IconFlagsNl", LazyIconFlagsNl],
["IconFlagsPl", LazyIconFlagsPl],
["IconFlagsPt", LazyIconFlagsPt],
["IconFlagsUs", LazyIconFlagsUs],
["IconForward", LazyIconForward],
["IconGerman", LazyIconGerman],
["IconGift", LazyIconGift],
["IconGlobe", LazyIconGlobe],
["IconGoogleMaps", LazyIconGoogleMaps],
["IconHeartActivePurple", LazyIconHeartActivePurple],
["IconHeartActive", LazyIconHeartActive],
["IconHeartBold", LazyIconHeartBold],
["IconHeartCircle", LazyIconHeartCircle],
["IconHeartFull", LazyIconHeartFull],
["IconHeartInactive", LazyIconHeartInactive],
["IconHeart", LazyIconHeart],
["IconHourglass", LazyIconHourglass],
["IconInfoOutlineSquare", LazyIconInfoOutlineSquare],
["IconInfoOutline", LazyIconInfoOutline],
["IconInfo", LazyIconInfo],
["IconInvoice", LazyIconInvoice],
["IconLeft", LazyIconLeft],
["IconLetter", LazyIconLetter],
["IconLocationMenu", LazyIconLocationMenu],
["IconLocation", LazyIconLocation],
["IconLock", LazyIconLock],
["IconLogo", LazyIconLogo],
["IconLogoutRound", LazyIconLogoutRound],
["IconLogout", LazyIconLogout],
["IconMail", LazyIconMail],
["IconMinus", LazyIconMinus],
["IconMultiplyOutline", LazyIconMultiplyOutline],
["IconNotify", LazyIconNotify],
["IconOrderMulti", LazyIconOrderMulti],
["IconOrder", LazyIconOrder],
["IconPasswordHide", LazyIconPasswordHide],
["IconPasswordShow", LazyIconPasswordShow],
["IconPayback", LazyIconPayback],
["IconPaymentDinersclub", LazyIconPaymentDinersclub],
["IconPaymentDiscover", LazyIconPaymentDiscover],
["IconPaymentKlarna", LazyIconPaymentKlarna],
["IconPaymentLastschrift", LazyIconPaymentLastschrift],
["IconPaymentMastercard", LazyIconPaymentMastercard],
["IconPaymentOspBankTransfer", LazyIconPaymentOspBankTransfer],
["IconPaymentOspKlarna", LazyIconPaymentOspKlarna],
["IconPaymentOspMastercard", LazyIconPaymentOspMastercard],
["IconPaymentOspPaypal", LazyIconPaymentOspPaypal],
["IconPaymentOspVisa", LazyIconPaymentOspVisa],
["IconPaymentOspVoucher", LazyIconPaymentOspVoucher],
["IconPaymentPaypal", LazyIconPaymentPaypal],
["IconPaymentRatepay", LazyIconPaymentRatepay],
["IconPaymentSofort", LazyIconPaymentSofort],
["IconPaymentVisa", LazyIconPaymentVisa],
["IconPen", LazyIconPen],
["IconPhone", LazyIconPhone],
["IconPlus", LazyIconPlus],
["IconPromotion", LazyIconPromotion],
["IconRadioOff", LazyIconRadioOff],
["IconRadioOn", LazyIconRadioOn],
["IconReturn", LazyIconReturn],
["IconRight", LazyIconRight],
["IconSameDelivery", LazyIconSameDelivery],
["IconScreenClick", LazyIconScreenClick],
["IconSearchBold", LazyIconSearchBold],
["IconSearch", LazyIconSearch],
["IconSelectionActive", LazyIconSelectionActive],
["IconSelection", LazyIconSelection],
["IconSettings", LazyIconSettings],
["IconShare", LazyIconShare],
["IconShippingDhl", LazyIconShippingDhl],
["IconShippingUps", LazyIconShippingUps],
["IconSnipesAccount", LazyIconSnipesAccount],
["IconSnipesAddress", LazyIconSnipesAddress],
["IconSnipesAppandroid", LazyIconSnipesAppandroid],
["IconSnipesAppapple", LazyIconSnipesAppapple],
["IconSnipesArrowcarouselsleft", LazyIconSnipesArrowcarouselsleft],
["IconSnipesArrowcarouselsright", LazyIconSnipesArrowcarouselsright],
["IconSnipesArrowcircledown", LazyIconSnipesArrowcircledown],
["IconSnipesArrowcircleleft", LazyIconSnipesArrowcircleleft],
["IconSnipesArrowcircleright", LazyIconSnipesArrowcircleright],
["IconSnipesArrowcircleup", LazyIconSnipesArrowcircleup],
["IconSnipesArrowsmalldown", LazyIconSnipesArrowsmalldown],
["IconSnipesArrowsmallleft", LazyIconSnipesArrowsmallleft],
["IconSnipesArrowsmallright", LazyIconSnipesArrowsmallright],
["IconSnipesArrowsmallup", LazyIconSnipesArrowsmallup],
["IconSnipesBackarrowcircle", LazyIconSnipesBackarrowcircle],
["IconSnipesBacktotoparrow", LazyIconSnipesBacktotoparrow],
["IconSnipesBadgediscount", LazyIconSnipesBadgediscount],
["IconSnipesBarcode", LazyIconSnipesBarcode],
["IconSnipesBurgermenu", LazyIconSnipesBurgermenu],
["IconSnipesCalendarevents", LazyIconSnipesCalendarevents],
["IconSnipesCheckmarkcircleoutlined", LazyIconSnipesCheckmarkcircleoutlined],
["IconSnipesCheckmarkcirclesolid", LazyIconSnipesCheckmarkcirclesolid],
["IconSnipesCirclepause", LazyIconSnipesCirclepause],
["IconSnipesCircleplay", LazyIconSnipesCircleplay],
["IconSnipesClosecircleoutlined", LazyIconSnipesClosecircleoutlined],
["IconSnipesClosecirclesolid", LazyIconSnipesClosecirclesolid],
["IconSnipesCoinsoutlined", LazyIconSnipesCoinsoutlined],
["IconSnipesCookie", LazyIconSnipesCookie],
["IconSnipesCopy", LazyIconSnipesCopy],
["IconSnipesCountryselection", LazyIconSnipesCountryselection],
["IconSnipesDashboard", LazyIconSnipesDashboard],
["IconSnipesDeletetrash", LazyIconSnipesDeletetrash],
["IconSnipesDeliveryclickandcollect", LazyIconSnipesDeliveryclickandcollect],
["IconSnipesDeliveryhomedelivery", LazyIconSnipesDeliveryhomedelivery],
["IconSnipesDeliverypickupstation", LazyIconSnipesDeliverypickupstation],
["IconSnipesDeliverytruck", LazyIconSnipesDeliverytruck],
["IconSnipesEdit", LazyIconSnipesEdit],
["IconSnipesEditprofile", LazyIconSnipesEditprofile],
["IconSnipesExclamationmarkoutlined", LazyIconSnipesExclamationmarkoutlined],
["IconSnipesExclamationmarksolid", LazyIconSnipesExclamationmarksolid],
["IconSnipesFacebook", LazyIconSnipesFacebook],
["IconSnipesFacehappy", LazyIconSnipesFacehappy],
["IconSnipesFaceneutral", LazyIconSnipesFaceneutral],
["IconSnipesFacesad", LazyIconSnipesFacesad],
["IconSnipesFaq", LazyIconSnipesFaq],
["IconSnipesFaqpayment", LazyIconSnipesFaqpayment],
["IconSnipesFaqvoucher", LazyIconSnipesFaqvoucher],
["IconSnipesFeedbackcheck", LazyIconSnipesFeedbackcheck],
["IconSnipesFeedbackx", LazyIconSnipesFeedbackx],
["IconSnipesFilterelement", LazyIconSnipesFilterelement],
["IconSnipesGeolocation", LazyIconSnipesGeolocation],
["IconSnipesGift", LazyIconSnipesGift],
["IconSnipesHeartoutlined", LazyIconSnipesHeartoutlined],
["IconSnipesHeartsolid", LazyIconSnipesHeartsolid],
["IconSnipesInfocircle", LazyIconSnipesInfocircle],
["IconSnipesInstagram", LazyIconSnipesInstagram],
["IconSnipesLogout", LazyIconSnipesLogout],
["IconSnipesMailboxed", LazyIconSnipesMailboxed],
["IconSnipesMailoutlined", LazyIconSnipesMailoutlined],
["IconSnipesMailsolid", LazyIconSnipesMailsolid],
["IconSnipesMinuscircle", LazyIconSnipesMinuscircle],
["IconSnipesMinuslight", LazyIconSnipesMinuslight],
["IconSnipesNewsletter", LazyIconSnipesNewsletter],
["IconSnipesOrders", LazyIconSnipesOrders],
["IconSnipesPackage", LazyIconSnipesPackage],
["IconSnipesPassword", LazyIconSnipesPassword],
["IconSnipesPaymentmethods", LazyIconSnipesPaymentmethods],
["IconSnipesPhoneboxed", LazyIconSnipesPhoneboxed],
["IconSnipesPhoneoutlined", LazyIconSnipesPhoneoutlined],
["IconSnipesPhonesolid", LazyIconSnipesPhonesolid],
["IconSnipesPluscircle", LazyIconSnipesPluscircle],
["IconSnipesPluslight", LazyIconSnipesPluslight],
["IconSnipesQrcode", LazyIconSnipesQrcode],
["IconSnipesReturn", LazyIconSnipesReturn],
["IconSnipesSearch", LazyIconSnipesSearch],
["IconSnipesSecureshopping", LazyIconSnipesSecureshopping],
["IconSnipesSecurityshield", LazyIconSnipesSecurityshield],
["IconSnipesSheetrecycle", LazyIconSnipesSheetrecycle],
["IconSnipesShoplight", LazyIconSnipesShoplight],
["IconSnipesShoppingbag", LazyIconSnipesShoppingbag],
["IconSnipesShoppingbagempty", LazyIconSnipesShoppingbagempty],
["IconSnipesShowpassword", LazyIconSnipesShowpassword],
["IconSnipesSpotify", LazyIconSnipesSpotify],
["IconSnipesStore", LazyIconSnipesStore],
["IconSnipesStorefinder", LazyIconSnipesStorefinder],
["IconSnipesTiktok", LazyIconSnipesTiktok],
["IconSnipesTrimanlogo", LazyIconSnipesTrimanlogo],
["IconSnipesWhatsapp", LazyIconSnipesWhatsapp],
["IconSnipesWishlist", LazyIconSnipesWishlist],
["IconSnipesWishlistsolid", LazyIconSnipesWishlistsolid],
["IconSnipesYoutube", LazyIconSnipesYoutube],
["IconSnipesZoomin", LazyIconSnipesZoomin],
["IconSnipesZoomout", LazyIconSnipesZoomout],
["IconSocialFacebook", LazyIconSocialFacebook],
["IconSocialInstagram", LazyIconSocialInstagram],
["IconSocialLinkedin", LazyIconSocialLinkedin],
["IconSocialMessenger", LazyIconSocialMessenger],
["IconSocialSnapchat", LazyIconSocialSnapchat],
["IconSocialTwitter", LazyIconSocialTwitter],
["IconSocialYoutube", LazyIconSocialYoutube],
["IconSsl", LazyIconSsl],
["IconTrash", LazyIconTrash],
["IconUp", LazyIconUp],
["IconUserSecondary", LazyIconUserSecondary],
["IconUser", LazyIconUser],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
